import { RouteConfig } from 'vue-router';

import { authResource } from '@/resources/auth.resource';

export const confirmDeleteRoute: RouteConfig = {
  path: '/confirmdelete/:token',
  name: 'confirmdelete',
  component: () => import(/* webpackChunkName: "ConfirmDelete" */ '@/views/startRoute/ConfirmDelete.vue')
};
